'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
require('angular-dynamic-locale');
exports.default = angular.module('winresCloud.core', ['tmh.dynamicLocale']);


//////////////////
// WEBPACK FOOTER
// ./src/core/module.js
// module id = 27
// module chunks = 0 2